var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{staticClass:"container-fluid"},[_c('HomeTop'),_c('HomeMiddle'),_c('HomeMiddle2'),_c('HomeBottom')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }